import React from 'react';

const StatCard = ({ title, value, icon, trend, trendValue, color = 'blue' }) => {
  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      trendUp: 'text-green-600',
      trendDown: 'text-red-600'
    },
    green: {
      bg: 'bg-green-50',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
      trendUp: 'text-green-600',
      trendDown: 'text-red-600'
    },
    purple: {
      bg: 'bg-purple-50',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      trendUp: 'text-green-600',
      trendDown: 'text-red-600'
    },
    yellow: {
      bg: 'bg-yellow-50',
      iconBg: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
      trendUp: 'text-green-600',
      trendDown: 'text-red-600'
    }
  };
  
  const colors = colorClasses[color] || colorClasses.blue;
  
  return (
    <div className={`${colors.bg} rounded-lg p-4`}>
      <div className="flex justify-between items-start mb-2">
        <div className={`${colors.iconBg} p-2 rounded-lg ${colors.iconColor}`}>
          {icon}
        </div>
        {trend && (
          <div className={`flex items-center ${trend === 'up' ? colors.trendUp : colors.trendDown}`}>
            {trend === 'up' ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            )}
            <span className="text-xs font-medium">{trendValue}</span>
          </div>
        )}
      </div>
      <div className="mt-2">
        <h3 className="text-gray-600 text-sm">{title}</h3>
        <div className="text-2xl font-bold mt-1">{value}</div>
      </div>
    </div>
  );
};

export default StatCard;